import { render } from "./MintNft.vue?vue&type=template&id=3a9f8605&scoped=true"
import script from "./MintNft.vue?vue&type=script&lang=js"
export * from "./MintNft.vue?vue&type=script&lang=js"

import "@/Common/Styles/mintNft.scss?vue&type=style&index=0&id=3a9f8605&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9f8605"]])

export default __exports__